<div class="general-settings d-sm-flex flex-column" [formGroup]="settingsForm">
    <h3>Chatbot Behavior</h3>

    <!-- Base URL Field -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Base URL</mat-label>
        <input matInput formControlName="baseUrl" placeholder="https://example.com" type="url">
        @if (settingsForm.get('baseUrl')?.hasError('required') && settingsForm.get('baseUrl')?.touched) {
            <mat-error>
                Base URL is required
            </mat-error>
        }
        @if (settingsForm.get('baseUrl')?.hasError('pattern') && settingsForm.get('baseUrl')?.touched) {
            <mat-error>
                Enter a valid URL (must start with http:// or https://)
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Conversation Retention Days (Override)</mat-label>
        <input matInput formControlName="conversationRetentionDays" min="1" max="3650"
               placeholder="Leave empty to use client/default retention" type="number">
        <mat-hint>Optional chatbot-level TTL override.</mat-hint>
        @if (settingsForm.get('conversationRetentionDays')?.hasError('min') || settingsForm.get('conversationRetentionDays')?.hasError('max')) {
            <mat-error>
                Value must be between 1 and 3650 days.
            </mat-error>
        }
    </mat-form-field>

    <!-- New Accordion for Additional Fields -->
    <mat-accordion>
        <!-- GPT Lucene Query -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Instructions
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="d-sm-flex flex-column">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Security and classification instructions</mat-label>
                    <textarea formControlName="gptClassificationAndSanitizeQuery" matInput
                              placeholder="Enter your query" rows="5"></textarea>
                    @if (settingsForm.get('gptClassificationAndSanitizeQuery')?.invalid && settingsForm.get('gptClassificationAndSanitizeQuery')?.touched) {
                        <mat-error>
                            Security and classification instructions required
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Classification model</mat-label>
                    <input
                        matInput
                        formControlName="classificationModel"
                        placeholder="Leave blank for default"
                        [matAutocomplete]="classificationModelAuto"
                        autocomplete="off"
                        spellcheck="false">
                    <mat-autocomplete #classificationModelAuto="matAutocomplete" [displayWith]="displayModelValue">
                        @for (option of filteredClassificationModelOptions; track option.value) {
                            <mat-option [value]="option.value">
                                {{ option.label }}
                                @if (!option.configured) {
                                    <span class="text-muted">(not configured)</span>
                                }
                            </mat-option>
                        }
                    </mat-autocomplete>
                    <mat-hint>Used for sanitization + assistant selection.</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Assistant instructions (applied across assistants)</mat-label>
                    <textarea formControlName="assistantInstructions" matInput
                              placeholder="Shared instructions used for all assistants in this chatbot"
                              rows="5"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Instructions for selecting products</mat-label>
                    <textarea formControlName="gptLuceneQuery" matInput placeholder="Enter GPT Lucene Query"
                              rows="5"></textarea>
                    @if (settingsForm.get('gptLuceneQuery')?.invalid && settingsForm.get('gptLuceneQuery')?.touched) {
                        <mat-error>
                            Instructions for selecting products required
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Instructions for summarising chats</mat-label>
                    <textarea formControlName="chatSummaryPrompt" matInput placeholder="Enter Chat Summary Prompt"
                              rows="5"></textarea>
                    @if (settingsForm.get('chatSummaryPrompt')?.invalid && settingsForm.get('chatSummaryPrompt')?.touched) {
                        <mat-error>
                            Instructions for summarising chats is required
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Instructions for proposing new sample messages</mat-label>
                    <textarea formControlName="proposeSampleMessagesPrompt" matInput
                              placeholder="Enter Propose Sample Messages Prompt" rows="5"></textarea>
                    @if (settingsForm.get('proposeSampleMessagesPrompt')?.invalid && settingsForm.get('proposeSampleMessagesPrompt')?.touched) {
                        <mat-error>
                            Instructions for proposing new sample messages is required
                        </mat-error>
                    }
                </mat-form-field>

                <mat-slide-toggle formControlName="usePromptCaching">
                    Enable prompt cache for classification & sanitization
                </mat-slide-toggle>

            </div>
        </mat-expansion-panel>
    </mat-accordion>

</div>
